
export const leftMenu = [
  {

    menuName: '资源要素',
    path: '/screen/homePage',

  },
  {

    menuName: '区域拓扑',
    path: '/screen/regionalTopology',

  },
  {

    menuName: '系统协同',
    path: '/screen/systemsCooperation',

  },
];
export const rightMenu = [
  {

    menuName: '仿真调控',
    path: '/screen/simulationRegulation',

  },
  {

    menuName: '调控日历',
    path: '/screen/regulatoryCalendar',

  },
  {

    menuName: '效果评估',
    path: '/screen/effectAppraisal',

  },
];


